import { render } from "./ImsiTypeDialog.vue?vue&type=template&id=71311971"
import script from "./ImsiTypeDialog.vue?vue&type=script&lang=js"
export * from "./ImsiTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__